import React from 'react';
import { Check, X } from 'lucide-react';

const ToggleSwitch = ({ checked, onChange, label, disabled = false, size = 'default' }) => {
  const sizeClasses = {
    small:   { width: '32px', height: '16px' },
    default: { width: '44px', height: '24px' },
    large:   { width: '56px', height: '32px' },
  };
  const thumbSizes = {
    small:   { width: '12px', height: '12px' },
    default: { width: '20px', height: '20px' },
    large:   { width: '28px', height: '28px' },
  };
  const iconSizes = { small: 8, default: 12, large: 16 };

  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        marginBottom: '10px',
        textAlign: 'left',
      }}
    >
      <div
        style={{
          position: 'relative',
          flexShrink: 0,
          ...sizeClasses[size],
          background: checked
            ? 'linear-gradient(135deg, #00A19D 0%, #00857E 100%)'
            : '#E2E5EB',
          borderRadius: '999px',
          transition: 'background 220ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 220ms ease',
          cursor: disabled ? 'not-allowed' : 'pointer',
          boxShadow: checked
            ? '0 4px 12px rgba(0, 161, 157, 0.30), inset 0 0 0 1px rgba(0,0,0,0.04)'
            : 'inset 0 1px 2px rgba(20, 30, 60, 0.10)',
        }}
        onClick={!disabled ? onChange : undefined}
      >
        <div
          style={{
            position: 'absolute',
            top: '2px',
            left: checked ? `calc(100% - ${thumbSizes[size].width} - 2px)` : '2px',
            ...thumbSizes[size],
            background: 'white',
            borderRadius: '50%',
            transition: 'left 240ms cubic-bezier(0.34, 1.4, 0.64, 1), box-shadow 200ms ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 6px rgba(20, 30, 60, 0.20), 0 0 0 1px rgba(20, 30, 60, 0.04)',
          }}
        >
          {checked ? (
            <Check size={iconSizes[size]} color="#00A19D" strokeWidth={3} />
          ) : (
            <X size={iconSizes[size]} color="#A3ABB8" strokeWidth={3} />
          )}
        </div>
      </div>
      <span
        style={{
          fontSize: size === 'small' ? '12px' : size === 'large' ? '16px' : '13.5px',
          fontWeight: 500,
          color: '#1A1F36',
          userSelect: 'none',
          textAlign: 'left',
          flex: 1,
          minWidth: 0,
          lineHeight: 1.3,
        }}
      >
        {label}
      </span>
    </label>
  );
};

export default ToggleSwitch;
